import {Divider as AntDivider} from "antd";

export const Divider = AntDivider;
export default Divider;
